module.exports = __webpack_public_path__ + "static/media/bomb_toss.3c1d0f5b.png";